import { cn } from '@/lib/utils'
import React, { PropsWithChildren, ReactElement } from 'react'

interface SectionWrapperProps {
  title?: string | ReactElement
  backgroundUrl?: string
  className?: string
  description?: string | ReactElement
  between?: React.ReactNode
}

const SectionWrapper: React.FC<PropsWithChildren<SectionWrapperProps>> = ({
  title,
  backgroundUrl,
  className,
  description,
  between,
  children,
}) => {
  return (
    <section
      className={cn('relative flex flex-col overflow-x-clip border-none bg-cover', className)}
      style={{
        backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : undefined,
      }}
    >
      <h1 className="!font-libre-baskerville px-1 text-center text-[44px] leading-[1.15] md:px-0 md:text-[48px] xl:text-[72px]">
        {title}
      </h1>
      {description && (
        <p className="!font-space-grotesk mx-auto mb-0 mt-[4px] max-w-2xl px-1 text-center text-[24px] text-black/100 md:px-0">
          {description}
        </p>
      )}
      {between && <div className="mb-[64px] mt-[16px]">{between}</div>}
      {children}
    </section>
  )
}

export default SectionWrapper
